import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BaseDataService',
    controller: 'Equipment'
};

const methods = [
    'GetRegionEquipment',
    'GetEquipmentMangeList'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const EquipmentApi = ZJApi.defineNewApi('EquipmentApi', factory);

export default EquipmentApi;